import React from 'react';
import { motion } from 'framer-motion';

interface RevealProps {
  children: React.ReactNode;
  delay?: number;
  className?: string;
  as?: 'div' | 'li' | 'article';
}

const MotionTags = {
  div: motion.div,
  li: motion.li,
  article: motion.article,
};

// Only position is animated: content must stay visible even when the in-view
// trigger never fires (full-page captures, crawlers, missing IntersectionObserver).
const Reveal: React.FC<RevealProps> = ({ children, delay = 0, className, as = 'div' }) => {
  const Tag = MotionTags[as];
  return (
    <Tag
      className={className}
      data-reveal=""
      initial={{ y: 14 }}
      whileInView={{ y: 0 }}
      viewport={{ once: true, amount: 0.15 }}
      transition={{ duration: 0.45, ease: 'easeOut', delay: Math.min(delay, 0.3) }}
    >
      {children}
    </Tag>
  );
};

export default Reveal;
